import React from 'react';

import { TIntl, TIntlDictionary } from 'types/i18n';
import { clientDetailsIntl } from 'i18n/ru/clientDetailsIntl';
import { clientDetailsBillRowDictionaryRu } from 'i18n/ru/clientDetailsRowDictionaryRu';
import { ORIGIN_DOMAIN } from 'utils/constants';
import { adminNavigationIntl } from 'i18n/ru/adminNavigationIntl';
import { productDetailsIntl } from 'i18n/ru/productDetailsIntl';
import { productsTableColumnsIntl } from 'i18n/ru/productsTableColumnsIntl';
import { subscriptionsTableColumnsIntl } from 'i18n/ru/subscriptionsTableColumnsIntl';
import { subscriptionDetailsIntl } from 'i18n/ru/subscriptionDetailsIntl';
import { cardPaymentsTableColumnsIntl } from 'i18n/ru/cardPaymentsTableColumnsIntl';
import {
  cardPaymentDetailsIntl,
  paymentExtraDetailsIntl,
} from 'i18n/ru/paymentDetailsIntl';
import { localeIntl } from 'i18n/ru/localeIntl';
import { debitsTableColumnsIntl } from 'i18n/ru/debitsTableColumnsIntl';
import { demoStackManagerIntl } from 'i18n/ru/demoStackManagerIntl';
import { prodStackManagerIntl } from 'i18n/ru/prodStackManagerIntl';
import { implicitAuthFormDictionaryRu } from 'i18n/ru/implicitAuthFormIntl';
import { TextComponent } from 'design/text/textComponents';
import { partnerRegistrationManagerDictionaryRu } from 'i18n/ru/partnerRegistrationManagerDictionaryRu';
import { sharedDictionaryRu } from 'i18n/ru/sharedDictionaryRu';
import { partnerDashboardDictionaryRu } from 'i18n/ru/partnerDashboardDictionaryRu';
import { partnerDashboardPageActiveDictionaryRu } from 'i18n/ru/partnerClientsPageActiveDictionaryRu';
import { partnerDashboardPageCancelledDictionaryRu } from 'i18n/ru/partnerClientsPageCancelledDictionaryRu';
import { partnerAccountManagerDictionaryRu } from 'i18n/ru/partnerAccountManagerDictionaryRu';
import { passwordChangeFormDictionaryRu } from 'i18n/ru/passwordChangeFormDictionaryRu';
import { partnersTableDictionaryRu } from 'i18n/ru/partnersTableDictionaryRu';
import { partnersPageDictionaryRu } from 'i18n/ru/partnersPageDictionaryRu';
import { partnerManagerDictionaryRu } from 'i18n/ru/partnerManagerDictionaryRu';
import { partnerClientsTableDictionaryRu } from 'i18n/ru/partnerClientsTableDictionaryRu';
import { secretCodeEditorDictionaryRu } from 'i18n/ru/secretCodeEditorDictionaryRu';
import { partnerClientManagerDictionaryRu } from 'i18n/ru/partnerClientManagerDictionaryRu';
import { giroPaymentsTableColumnsIntl } from 'i18n/ru/giroPaymentsTableColumnsIntl';
import { billsTableColumnsDictionaryRu } from 'i18n/ru/billsTableColumnsDictionaryRu';
import { promocodesTableColumnsDictionaryRu } from 'i18n/ru/promocodesTableColumnsDictionaryRu';
import { promocodesPageDictionaryRu } from 'i18n/ru/promocodesPageDictionaryRu';
import { giroPaymentManagerDictionaryRu } from 'i18n/ru/giroPaymentManagerDictionaryRu';
import { refundFormDictionaryRu } from 'i18n/ru/refundFormDictionaryRu';
import { promocodePasswordEditorDictionaryRu } from 'i18n/ru/promocodePasswordEditorDicitionaryRu';
import { promocodeRegistrationManagerDictionaryRy } from 'i18n/ru/promocodeRegistrationManagerDictionaryRy';
import { partnerFinancesTableDictionaryRu } from './partnerFinancesTableDictionaryRu';

const dictionary: TIntlDictionary = {
  shared: sharedDictionaryRu,
  locale: localeIntl,

  registerAgreement(link1, link2) {
    return (
      <>
        Нажимая «Продолжить», вы подтверждаете, что принимаете{'\n'}
        {link1} и {link2}.
      </>
    );
  },

  registerSignIn(link) {
    return <>Уже зарегистрированы? {link}</>;
  },
  registerSignInLinkText: 'Войти',

  registerTermsUrl: 'Пользовательское соглашение',
  registerPrivacyUrl: 'Политику конфиденциальности',

  paginationBack: 'назад',
  paginationForward: 'вперед',

  pageSizeLabel: (size: number) => `Показывать по ${size}`,

  missingTableDataFallbackText: 'Не указано',

  cancelButton: 'Отмена',
  continueButton: 'Продолжить',
  registerButton: 'Зарегистрироваться',
  logOutButton: 'Выйти',
  saveButton: 'Сохранить',
  saveChangesButton: 'Сохранить изменения',
  closeButton: 'Закрыть',
  sendButton: 'Отправить',
  authorizeWithGoogleButton: 'Продолжить с Google',

  tokenExpirationError: 'Ссылка больше не действительна',
  emailAlreadyInUseError: 'Этот email уже используется',
  domainAlreadyInUseError: 'Это имя уже используется',
  createStackError: 'Извините, у нас проблемы.\nПопробуйте через 5 минут.',
  demoLoginAlreadyInUse:
    'В демо-приложении уже есть пользователь с вашим email. Чтобы получить доступ к новому демо, смените свой email.',
  captchaError: 'Проблемы с капчей, обновите страницу',
  wrongPasswordError: 'Неверный пароль',
  wrongSecretCode: 'Неверный код доступа',
  demoCreationSuspendedTitle: 'Демо временно недоступно',
  demoCreationSuspendedDescription: `Извините, демо приложение временно недоступно\nиз-за большого количества желающих его посмотреть.\nПопробуйте запустить демо позже.`,
  demoCreationSuspendedRetry: 'Запустить демо еще раз',

  firstNameInputPlaceholder: 'Имя',
  lastNameInputPlaceholder: 'Фамилия',
  middleNameInputPlaceholder: 'Отчество',
  positionInputPlaceholder: 'Должность',
  companyInputPlaceholder: 'Организация',
  staffInputPlaceholder: 'Штат организации',
  phoneInputPlaceholder: 'Телефон',
  emailInputPlaceholder: 'Ваш email',
  partnerCodeInputPlaceholder: 'Код партнера',
  nextEmailInputPlaceholder: 'Новый email',
  codeInputPlaceholder: '',
  passwordInputPlaceholder: 'Пароль',
  yourPasswordInputPlaceholder: 'Ваш пароль',
  repeatPasswordInputPlaceholder: 'Подтвердите пароль',
  actualPasswordInputPlaceholder: 'Текущий пароль',
  nextPasswordInputPlaceholder: 'Новый пароль',
  nextPasswordRepeatInputPlaceholder: 'Подтвердите пароль',
  commentInputPlaceholder: 'Ваше сообщение',
  branchInputPlaceholder: 'Отрасль',
  dnsInputPlaceholder: 'domennoe-imya',
  groupedStackInputPlaceholder: 'Групповой стек',
  groupedStackTypeInputPlaceholder: 'Тип группового стека',
  productNameInputPlaceholder: 'Название',
  productDefaultPartnerComissionInputPlaceholder: 'Доля партнера, %',
  costInputPlaceholder: 'Цена в мес, $',
  expiresAtInputPlaceholder: 'Окончание',
  locationInputPlaceholder: 'Страна регистрации',
  clientSearchTextPlaceholder: 'Название организации или ФИО клиента',

  inputValidationRequired: 'Это обязательное поле',
  inputValidationPasswordsMatch: 'Указанные пароли не совпадают',
  inputValidationPassswordLength: 'Минимум 6 символов',
  inputValidationWrongPassword: 'Вы указали неправильный пароль',
  inputValidationEmail: 'Введите email в формате email@site.ru',
  inputValidationEmailNotFound: 'Пользователь с таким email не найден',
  inputValidationMatchWithEmail: 'Не должен совпадать с email',
  inputValidationDns: 'Некорректный формат',
  inputValidationMaxLength: (length: number) => `Не больше ${length} символов`,
  inputValidationWrongEmailOrPassword: 'Неверный email или пароль',
  inputValidationPartnerCodeIsTooShort: 'Введите код из 4 символов',
  inputValidationTariffUpdateIsForbidden:
    'По данному тарифу уже создан счет. Создайте новый тариф',
  inputValidationSearchTextTooShort:
    'Укажите 3 и более символа для начала поиска',
  inputValidationClientNotSelected: 'Выберите клиента в результате поиска',
  inputValidationAmountExceedsBalance: 'На балансе недостаточно средств',
  inputValidationClientHasNoRequisites: 'Реквизиты не заполнены',
  inputValidationIncorrectValue: 'Недопустимое значение',
  inputValidationClientBindingIsNotPossible:
    'Подписка клиента отменена. Такого клиента привязать нельзя',

  agreement: 'Соглашение пользователя',
  terms: 'Лицензионное соглашение',
  payReturn: 'Оплата и возврат покупки',
  privacy: 'Политика обработки персональных данных',

  userFormTitleDemo: 'Ваша персональная демоверсия',
  userFormTitleProd: 'Покупка программы',
  userFormDescriptionDemo:
    'Заполните анкету и получите доступ к демоверсии AGM',
  userFormDescriptionProd:
    'Заполните анкету и получите доступ к вашей программе AGM',
  userFormPolicyWarningPrefix:
    'Продолжая регистрацию, вы даете согласие на обработку персональных данных и соглашаетесь c ',
  userFormPolicyWarningLink: 'политикой конфиденциальности',

  confirmEmailTitle: 'Подтвердите email',
  confirmEmailDescription: (email: string) =>
    `На электронную почту ${email}\nотправлена ссылка подтверждения email.\nПосле подтверждения вы сможете создать свой AGM.`,
  confirmEmailNotRecieved: 'Не получили письмо?',
  confirmEmailRetry: 'Отправить повторно',

  passwordFormTitle: 'Придумайте ваш пароль',

  appFallback: {
    titleText: 'Ошибка',
    criticalDetailsText(mailLink, tgLink) {
      return (
        <TextComponent>
          Повторите действие через несколько минут или напишите в поддержку:
          {'\n'}
          email {mailLink}, telegram {tgLink}
        </TextComponent>
      );
    },
  },

  homePage: {
    demoTitleText: 'Демоверсия',
    demoDescriptionText: () => (
      <TextComponent>
        Вы сможете «потрогать» и изучить каждый раздел программы AGM.{`\n\n`}
        Добавляйте, меняйте и удаляйте любые данные — демоверсия только для вас.
      </TextComponent>
    ),
    demoActionText: 'Создать демоверсию',
    prodTitleText: 'Ваш AGM',
    prodDescriptionText: () => (
      <TextComponent>
        Первые 14 дней использование программы — бесплатно.{`\n\n`}Во время
        пробного периода вы сможете использовать программу без ограничений.
      </TextComponent>
    ),
    prodActionText: 'Создать свой AGM',
    profileInfoLabel: 'Личные данные',
    orgInfoLabel: 'Организация',
  },

  clientPasswordEditor: {
    titleText: 'Новый пароль',
    descriptionText: 'Придумайте ваш новый пароль',
    actionText: 'Сохранить',
  },

  demoStackManager: demoStackManagerIntl,

  restorePasswordPage: {
    emailFormTitleText: 'Восстановление вашего пароля',
    emailFormDescriptionText:
      'Укажите email, на который мы отправим инструкцию по восстановлению пароля',
    emailCongratsTitleText: 'Проверьте почту',
    emailCongratsDescriptionText(email) {
      return (
        <TextComponent>
          На электронную почту{' '}
          <TextComponent weight="bold">{email}</TextComponent> отправлена
          инструкция по восстановлению пароля.
        </TextComponent>
      );
    },
    actionText: 'Отправить',
  },

  authorizedWarningModal: {
    title: 'Добро пожаловать',
    paragraph1: (
      <span>
        {`Мы еще не закончили разрабатывать наш сайт.\nНо в связи с большим количеством желающих узнать о нашей\nпрограмме, мы решили открыть для всех `}
        <b>бета-версию</b>
        {` сайта.`}
      </span>
    ),
    paragraph2: `Пока у нас не работают платежи, вы можете ознакомиться\nс Презентацией или войти в Личный кабинет и запустить\nдемо-версию программы AGM.`,
    action1Title: 'Посмотреть презентацию',
    action2Title: 'Войти в личный кабинет',
    action1Description:
      'Скриншоты основных разделов программы и описание их работы',
    action2Description: 'Управление вашей анкетой, запуск программы AGM',
  },

  restorePasswordEmailFormTitle: 'Восстановление пароля',
  restorePasswordEmailFormDescription:
    'Укажите email, на который мы отправим\nинструкцию по восстановлению пароля',
  restorePasswordEmailConfirmationScreenTitle: 'Перейдите в свою почту',
  restorePasswordEmailConfirmationScreenDescription: (emailAddress: string) =>
    `На электронную почту ${emailAddress}\nотправлена инструкция по восстановлению пароля.`,
  restorePasswordPasswordFormTitle: 'Придумайте ваш пароль',
  restorePasswordPageRegisterLink: 'Зарегистрироваться',
  restorePasswordPageSignInLink: 'Войти',

  dashboardRowActivePlanTitle: 'Подписка',
  dashboardRowProdStackTitle: 'Ваш AGM',
  dashboardRowDemoStackTitle: 'Демо AGM',
  dashboardRowPaymentsTitle: 'Платежи',
  dashboardRowAccountTitle: 'Аккаунт',
  dashboardRowProfileTitle: 'Анкета',

  dashboardProlongActivePlanAction: 'Продлить подписку',
  dashboardEditProfileAction: 'Редактировать',
  dashboardChangePasswordAction: 'Изменить пароль',
  dashboardChangeEmailAction: 'Изменить email',
  dashboardGetPlanForFreeAction: 'Попробовать бесплатно',
  dashboardCreateDemoAction: 'Создать демо-программу',
  dashboardCreateProdAction: 'Начать бесплатно',

  dashboardProdStackMissingHint: 'Для ознакомления 14 дней бесплатно',
  dashboardProdStackPendingHint(email) {
    return `В течение 30 минут вы получите доступ\nк своему AGM и получите уведомление\nна почту ${email} со ссылкой для входа в программу`;
  },
  dashboardProdStackApprovalHint: (email: string) =>
    `Администратор сначала проверит вашу анкету, а затем создаст для вас AGM. После этого вы получите уведомление на почту ${email}`,
  dashboardProdStackDeployHint: (email: string) =>
    `В течение 15 минут вы получите доступ\nк своему AGM и получите уведомление\nна почту ${email} со ссылкой для активации приложения`,
  dashboardProdStackActiveHint: (email: string, date: string) =>
    `Для активации вашего аккаунта перейдите\nпо ссылке, отправленной вам на почту\n${email}\n\nПодписка до: ${date}`,
  dashboardProdStackExpiredHint: (date: string) =>
    `Подписка истекла: ${date}.\nПожалуйста, выберите тарифный план`,

  dashboardEmailEditorSuccess: (email: string) =>
    `Письмо со ссылкой на подтверждение отправлено на ${email}. Перейдите по ссылке для завершения процесса смены email.`,
  dashboardEmailEditorDescription:
    'Укажите пароль и новый email, который будете использовать для входа на сайт',

  dashboardProdStackPendingLabel: 'Программа создается',
  dashboardStackURLLabel: 'Адрес приложения',
  dashboardProdEmailLabel: 'Email собственника',
  dashboardDemoEmailLabel: 'Email',
  dashboardEmailLabel: 'Логин',
  dashboardPasswordLabel: 'Пароль',
  dashboardFullNameLabel: 'Полное имя',
  dashboardPositionLabel: 'Должность',
  dashboardCompanyLabel: 'Организация',
  dashboardStaffLabel: 'Штат организации',
  dashboardPhoneLabel: 'Телефон',
  dashboardNoActivePlanLabel: 'Подписка не куплена',
  dashboardNoProdStackLabel: 'Приложение не создано',
  dashboardDemoStackMissingHint:
    'Вы можете посмотреть как выглядит\nпрограмма, заполненная данными',
  dashboardDemoStackActiveHint:
    'Не храните в программе важные данные,\nона будет удалена автоматически',
  dashboardNoPaymentsLabel: 'Платежей еще не было',
  dashboardProdStackApprovalLabel: 'Проверка данных',
  dashboardProdStackDeployLabel: 'Приложение создается',

  clientsPageSearchPlaceholder: 'Поиск по организации и ФИО',
  billsPageSearchPlaceholder: 'Поиск по номеру счeта, организации и ФИО',

  cardPaymentsPageSearchPlaceholder: 'Поиск по организации и ФИО',
  giroPaymentsPageSearchPlaceholder:
    'Поиск по УНП (ИНН / TIN), организации и ФИО',

  createProdStackModalTitle: 'Создание AGM',
  stackDomainInputLabelTitle: 'Придумайте имя вашего приложения',
  stackDomainInputLabelDescription: `У каждой организации, использующей AGM, есть свое короткое доменное имя, по которому все сотрудники входят в программу. Например: abc.${ORIGIN_DOMAIN}`,
  stackDomainInputPlaceholder: 'domennoe-imya',
  createProdStackModalCancel: 'Отмена',
  createProdStackModalSubmit: 'Далее',
  createProdStackModalHint: `Администратор сначала проверит ваши данные, а затем создаст для вас AGM`,

  faqSubHeaderTitle: 'Важные вопросы',
  faqSubHeaderSubTitle: '',

  pricesSubHeaderTitle: 'Цены',
  pricesSubHeaderSubTitle: '',

  academySubHeaderTitle: 'Академия AGM',
  academySubHeaderSubTitle:
    'Получите знания практического менеджмента без отрыва от работы',

  guideSubHeaderTitle: 'Гайд по AGM',
  guideSubHeaderSubTitle: 'Полное руководство по программе для менеджеров',

  guideHrSubHeaderTitle: 'Гайд для HR-специалистов',
  guideHrSubHeaderSubTitle: 'Руководство по поиску и подбору персонала',

  aboutSubHeaderTitle: 'AGMsoft',
  aboutSubHeaderSubTitle: 'Понять главное. Успеть вовремя. Достичь большего.',

  consultingSubHeaderTitle: 'Консалтинг',
  consultingSubHeaderSubTitle: 'Обучение руководителей важно и необходимо.',

  contactUsEditorTitle: 'Ваше письмо',
  contactUsEditorDescription: 'Напишите и мы свяжемся с вами',
  contactUsEditorSubTitle: 'Представьтесь, пожалуйста:',
  contactUsSucceededTitle: 'Спасибо за обращение',
  contactUseSucceededDescription:
    'Ваше сообщение отправлено.\nМы свяжемся с вами в ближайшее время.',

  academyMenu: ['Обучение', 'Рекомендации', 'Статьи', 'Видео', 'Мотиваторы'],

  landingPageVariables: {
    mainBlock: {
      title: 'Система управления\n подчиненными',
      hint: '',
    },
  },

  goToMain: 'На главную',
  goToTableOfContents: 'В академию',
  back: 'Назад',
  forward: 'Вперед',
  zoomIn: 'Увеличить',
  zoomOut: 'Уменьшить',

  access: {
    theoryPasswordTitle: 'Ознакомиться\nс подробной теорией AGM',
    presentationPasswordTitle: 'Ознакомиться\nс подробной презентацией',
    demoEmailTitle: 'Вы можете создать\n персональную демоверсию программы',
    demoLoaderTitle: 'Ваше демо создается',
    demoSucceededTitle: 'Ваше демо создано',
    demoSucceededLinkLabel: 'Открыть в новом окне',
    proceedButtonLabel: 'Далее',
    credentialsScreenTitle: 'Укажите ваши\nлогин и пароль',
    signInButtonText: 'Я зарегистрированный пользователь',
    contactUsButtonText: 'Написать нам',
    registerLinkLabel: 'Зарегистрироваться',
    restoreLinkLabel: 'Забыли пароль?',
    signOutButtonText: 'Выйти',
  },

  clientsTableColumns: {
    id: 'id',
    company: 'Организация',
    fullName: 'Полное имя',
    position: 'Должность',
    staff: 'Штат',
    phone: 'Телефон',
    email: 'Email',
    balance: 'Баланс',
    prodStack: 'Production',
    demoStack: 'Demo',
    registeredOn: 'Регистрация',
    updatedOn: 'Update',
  },

  productsTableColumns: productsTableColumnsIntl,
  subscriptionsTableColumns: subscriptionsTableColumnsIntl,

  clientDetails: clientDetailsIntl,

  prodStackManager: prodStackManagerIntl,

  groupedStackTypeDemo: 'Демо',
  groupedStackTypeMini: 'Мини',
  groupedStackTypeStandard: 'Стандарт',
  groupedStackTypeVIP: 'VIP',
  adminNavigation: adminNavigationIntl,
  productDetails: productDetailsIntl,
  subscriptionDetails: subscriptionDetailsIntl,
  cardPaymentsTableColumns: cardPaymentsTableColumnsIntl,
  giroPaymentsTableColumns: giroPaymentsTableColumnsIntl,
  cardPaymentDetails: cardPaymentDetailsIntl,
  paymentExtraDetails: paymentExtraDetailsIntl,
  debitsTableColumns: debitsTableColumnsIntl,
  implicitAuthForm: implicitAuthFormDictionaryRu,
  clientDetailsBillRow: clientDetailsBillRowDictionaryRu,
  partnerRegistrationManager: partnerRegistrationManagerDictionaryRu,
  partnerDashboard: partnerDashboardDictionaryRu,
  partnerClientsPageActive: partnerDashboardPageActiveDictionaryRu,
  partnerClientsPageCancelled: partnerDashboardPageCancelledDictionaryRu,
  partnerAccountManager: partnerAccountManagerDictionaryRu,
  partnerFinancesTable: partnerFinancesTableDictionaryRu,
  passwordChangeForm: passwordChangeFormDictionaryRu,
  partnersTable: partnersTableDictionaryRu,
  partnersPage: partnersPageDictionaryRu,
  partnerManager: partnerManagerDictionaryRu,
  partnerClientsTable: partnerClientsTableDictionaryRu,
  secretCodeEditor: secretCodeEditorDictionaryRu,
  partnerClientManager: partnerClientManagerDictionaryRu,
  billsTableColumns: billsTableColumnsDictionaryRu,
  giroPaymentManager: giroPaymentManagerDictionaryRu,
  refundForm: refundFormDictionaryRu,
  promocodesTableColumns: promocodesTableColumnsDictionaryRu,
  promocodesPage: promocodesPageDictionaryRu,
  promocodePasswordEditor: promocodePasswordEditorDictionaryRu,
  promoCodeRegistrationManager: promocodeRegistrationManagerDictionaryRy,

  appsPage: {
    contactsAppName: 'AGM Контакты',
    tasksAppName: 'AGM Задачи',
  },
  rewardFieldset: {
    amountInputLabel: 'Укажите сумму, $',
    commentInputLabel: 'Комментарий к выплате	',
    amountExceedsBalanceViolation: 'На балансе недостаточно средств',
  },
};

export const ruIntl: TIntl = {
  langCode: 'ru',
  dictionary,
};
